import app from '../app';
import LinkButton from '../../common/components/LinkButton';
import extractText from '../../common/utils/extractText';
import MinimalDiscussionListItem from './MinimalDiscussionListItem';

/**
 * The `PostsSearchSource` finds and displays post search results in
 * the search dropdown.
 */
export default class GlobalPostsSearchSource {
  results = new Map();
  resource = 'posts';
  title() {
    return extractText(app.translator.trans('core.lib.search_source.posts.heading'));
  }
  isCached(query) {
    return this.results.has(query.toLowerCase());
  }
  async search(query, limit) {
    query = query.toLowerCase();
    this.results.set(query, []);
    const params = {
      filter: {
        q: query
      },
      page: {
        limit
      },
      include: 'user,discussion.tags'
    };
    return app.store.find('posts', params).then(results => {
      this.results.set(query, results);
      m.redraw();
    });
  }
  view(query) {
    query = query.toLowerCase();
    return (this.results.get(query) || []).map(post => {
      return m("li", {
        className: "PostSearchResult",
        "data-index": 'posts' + post.id(),
        "data-id": post.id()
      }, m(MinimalDiscussionListItem, {
        discussion: post.discussion(),
        post: post,
        params: {
          q: query
        },
        jumpTo: post.number(),
        author: post.user()
      }));
    });
  }
  customGrouping() {
    return false;
  }
  fullPage(query) {
    const filter = app.search.gambits.apply('posts', {
      q: query
    });
    const q = filter.q || null;
    delete filter.q;
    return m("li", null, m(LinkButton, {
      icon: "fas fa-search",
      href: app.route('posts', {
        q,
        filter
      })
    }, app.translator.trans('core.lib.search_source.posts.all_button', {
      query
    })));
  }
  gotoItem(id) {
    const post = app.store.getById('posts', id);
    if (!post) return null;
    return app.route.post(post);
  }
}
flarum.reg.add('core', 'forum/components/GlobalPostsSearchSource', GlobalPostsSearchSource);